export const estimateStatuses = {
    "WAIT_OFFERS": "Ожидание предложений",
    "CALCULATED_OFFERS": "Расчитаны предложения",
    "PERFORMER_SELECTED": "Выбран исполнитель",
    "PERFORMER_CONFIRMED": "Исполнитель подтвержден",
    "SENT_TO_PRODUCTION": "Отправлен в производство",
    "CALCULATION": "Расчетная",
    "IN_WORK": "В работе",
    "CREATED_RESERVES": "Созданы резервы",
    "PURCHASE": "Заказать",
    "FORMAT_PURCHASE": "Формирование закупки",
    "PURCHASED": "Заказана",
    "COLLECTED": "Собрана",
    "PRODUCTION": "В производстве",
    "SHIPMENT": "Отгружена",
    "ARCHIVE": "Архив"
}

/** Заказ нельзя редактировать (номер / состав) после отправки в производство. */
export const isCustomerOrderEditLocked = (estimateState) =>
    estimateState === "SENT_TO_PRODUCTION";
